import { useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import WBRoutes from './WBRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([WBRoutes, LoginRoutes]);
}
